import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { getHealthDepartmentName, HealthDeptResponse } from 'services';

export type State = ApiState<HealthDeptResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchHealthDeptDetails = createAsyncThunk(
  'get/healthDeptDetails',
  async () => await getHealthDepartmentName()
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const healthDeptDetail = createSlice({
  name: 'healthDeptDetails',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchHealthDeptDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchHealthDeptDetails.fulfilled, (state, action: PayloadAction<HealthDeptResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchHealthDeptDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { healthDeptDetails: State }): State => state.healthDeptDetails;

export const healthDeptDetails_ = createSelector(stateSelector_, (state) => state.data);

export const healthDeptIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const healthDeptHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export default healthDeptDetail.reducer;
